import { gql, TypedDocumentNode } from '@apollo/client';

import { AuthorType } from '@shared/components/magazin/types';

import { GHOST_AUTHOR_FRAGMENT } from '../fragments/ghost-author';

export const GET_GHOST_AUTHORS: TypedDocumentNode<{ getGhostAuthors: { authors: AuthorType[] } }> = gql`
  query getGhostAuthors {
    getGhostAuthors {
      authors {
        ...GhostAuthor
      }
    }
  }
  ${GHOST_AUTHOR_FRAGMENT}
`;
